import React from 'react'
import { Link } from 'react-router-dom'
import { localized } from '@/decorators/localized'
import Name from '@/components/Name'
import { formatDate } from '@/utils/dateUtilities'
import { format } from '@/utils/StringUtilities'
import { ReportSubmissionGroupState } from '@/enums/ReportSubmissionGroupState'
import getEnumTranslation from '@/enums/enums'
import moment from 'moment'
import { reportSubmissionGroupStatus } from '@/components/reporting/submissions/reportSubmissionsStatus'

@localized()
class WidgetContent extends React.Component {
  renderItem (item, index) {
    const { localize, localizeValue } = this.props
    const institutionName = localizeValue(item.institutionName, item.institutionLatinName)
    const originInfo = format(localize('Reporting.From0By1'), institutionName, item.author)
    const dueDatePassedCss = (moment(item.dueDate).isBefore(moment()) ? 'report-item__due-date--pass' : '')

    return (
      <div key={index}>
        <Link to={`/report-submission-groups/${item.id}/report-submissions`} className='report-item'>
          <div className='report-item__info'>
            <div><Name data={item} /></div>
            <small>{originInfo}</small>
          </div>
          <div className={`report-item__due-date ${dueDatePassedCss}`}>
            <small>{localize('Reporting.DueDate')}</small>
            <span>{formatDate(item.dueDate)}</span>
          </div>
          <div className='report-item__status'>
            <span className={'status status--' + reportSubmissionGroupStatus(item.state)}>
              {getEnumTranslation({ localize, enumName: ReportSubmissionGroupState.enumName, value: item.state })}
            </span>
            <time>{formatDate(item.lastStateModificationTime, 'YYYY-MM-DD HH:mm')}</time>
          </div>
        </Link>
      </div>
    )
  }
  render () {
    const items = this.props.data || []
    return (
      <div className='dashboard-item__body'>
        <div style={{ maxHeight: 250 }}>
          {items.map((item, index) => this.renderItem(item, index))}
        </div>
      </div>
    )
  }
}

export default WidgetContent



// WEBPACK FOOTER //
// ./src/components/reporting/widgetContent.js